// AP-14: Typen des Auftrags-Scans im ERP (Scan-Regeln und ihr Testwerkzeug).

export type ScanTargetType = 'PROJECT' | 'POSITION' | 'STEP';

export interface ScanRefLite {
  id: string;
  name: string;
  projectNumber?: string;
  nummer?: number | null;
  kategorieTxt?: string | null;
  externalId?: string | null;
}

// ── AP-14-B: Scan-Regeln ──────────────────────────────────────────────────────
// Struktur-Definition statt Einzel-Zuordnung: eine Regel je Fremdsystem-Format
// beschreibt, wie ein Rohwert zerlegt und gegen die Ref-Tabellen geprüft wird.
// Gespeichert wird sie in TenantTimeConfig.scanRules (PATCH /time-config).

export type ScanRuleMode = 'delimiter' | 'fixed' | 'regex';
export type ScanRuleTarget = 'PROJECT' | 'POSITION' | 'STEP' | 'ACTIVITY';

/** Zulässige Vergleichsfelder je Ebene — Spiegel von SCAN_RULE_MATCH_FIELDS im Backend. */
export const SCAN_RULE_MATCH_FIELDS: Record<ScanRuleTarget, string[]> = {
  PROJECT: ['externalId', 'projectNumber'],
  POSITION: ['externalId', 'nummer'],
  STEP: ['externalId', 'nummer'],
  ACTIVITY: ['externalId', 'name'],
};

export interface ScanRuleSegment {
  target: ScanRuleTarget;
  matchOn: string;
  /** mode 'delimiter': 1-basierte Segmentnummer */
  index?: number;
  /** mode 'fixed': 0-basierter Start + Länge */
  from?: number;
  length?: number;
  /** mode 'regex': Name der benannten Gruppe */
  group?: string;
  trim?: boolean;
  stripLeadingZeros?: boolean;
  upperCase?: boolean;
}

export interface ScanRule {
  id: string;
  name: string;
  enabled: boolean;
  priority: number;
  prefix?: string;
  mode: ScanRuleMode;
  delimiter?: string;
  pattern?: string;
  segments: ScanRuleSegment[];
}

/** Ergebnis von POST /time-tracking/scan/rules/test — je Regel eine Zeile. */
export interface ScanRuleTraceSegment {
  target: ScanRuleTarget;
  matchOn: string;
  value: string;
  resolved: boolean;
}

export interface ScanRuleTrace {
  ruleId: string;
  ruleName: string;
  priority: number;
  applies: boolean;
  resolves: boolean;
  ambiguous: boolean;
  reason: string;
  segments: ScanRuleTraceSegment[];
}

export interface ScanRuleTestResult {
  rawValue: string;
  rulesEvaluated: number;
  matched: boolean;
  result: {
    ruleId: string;
    ruleName: string;
    targetType: ScanTargetType;
    projectRef: ScanRefLite | null;
    positionRef: ScanRefLite | null;
    stepRef: ScanRefLite | null;
    activityRef: ScanRefLite | null;
    ambiguous: boolean;
  } | null;
  trace: ScanRuleTrace[];
}
